import { atom, useAtom } from 'jotai';
import { SortOrder } from 'api/models/Sorting';
import { SurgeonsFilters, SurgeonsSortField } from 'api/models/Surgeons';

export const SURGEONS_INITIAL_FILTERS: SurgeonsFilters = {
  sort_order: SortOrder.Ascending,
  sort_by: SurgeonsSortField.surgeonName,
  search: '',
  verified: undefined,
  active: true,
};

const surgeonsFiltersAtom = atom(SURGEONS_INITIAL_FILTERS);

export const useSurgeonsFilters = () => useAtom(surgeonsFiltersAtom);
